<template>
  <div class="info-block" v-bind:class="'info-' + step" v-show="image">
    <img v-bind:src="getSrc(image)" alt="">
    <h4 class="de-break-word">{{ $t(title) }}</h4>
    <div class="details" v-html="$t(description)">
    </div>
  </div>
</template>

<script>
import imageMixin from '../mixins/image'

export default {
  name: 'InfoBlock',
  props: ['step', 'image', 'title', 'description'],
  mixins: [imageMixin]
}
</script>

<style scoped lang="scss">
.info-block {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  text-align: center;
  padding: 25px;
  background: #FFFFFF;

  img {
    max-width: 28px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.details {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #6E777A;
  margin-top: 20px;
}

.info-6 {
  img {
    max-width: 28px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.info-7 {
  .details {
    padding-bottom: 25px;
  }

  img {
    max-width: 28px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

[lang="et"] {
  .info-7, .info-6{
    h4{
      font-size:30px;
    }
  }
}
</style>
